module.exports = __webpack_public_path__ + "static/media/locationwhite.ae8ba443.png";